import IPrayer from "../../interfaces/IPrayer";
import IApiResponse from "../../interfaces/IApiResponse";
import SuccessApiResponse from "../../data/SuccessApiResponse";
import { PrayerStatusValues } from "../../data/PrayerStatus";
import { IPrayerService } from "../PrayerService";
import SQLiteHelperService from "../SQLiteHelperService";
import { SQLiteTables } from "../../data/SQLiteTables";
import SQLiteDB from "../../data/SQLiteDB";
import ISQLiteResponse from "../../interfaces/ISQLiteResponse";

const dbFailedResponse = Promise.resolve({
    Data: undefined,
    Success: false,
    Message: { UserMessage: 'db not connected', ServerMessage: 'db not connected' }});

const PrayerServiceHybrid: IPrayerService = {
    createPrayer: async (prayer) => {
        const newPrayer: any  = {...prayer};
        delete newPrayer.id;
        const query = SQLiteHelperService.insertQuery(SQLiteTables.prayers, newPrayer);
        const db = await SQLiteDB();

        if(db) {
            const dbResponse: Promise<IApiResponse<IPrayer>> = db.executeSql(query, []).then((result:ISQLiteResponse<IPrayer>)=>{
                    prayer.id = result.insertId;
                    const response = {...SuccessApiResponse, Data: prayer};
                    response.Message.UserMessage = 'SUCCESS: ADDED NEW PRAYER.';
                    return response;
            }).catch((error)=>{
                const response = {
                    Data: prayer,
                    Success: false,
                    Message: { UserMessage: error.toString(), ServerMessage: error.toString() }
                }
                console.log(error);
                return response as IApiResponse<IPrayer>;
            });

            return dbResponse;
        } else {
            return dbFailedResponse;
        }
    },

    getPrayer: async (prayerId) =>  {
        const query = `SELECT * FROM ${SQLiteTables.prayers} WHERE \`id\`=${prayerId}`;
        const db = await SQLiteDB();
        if(db) {
            const dbResponse: Promise<IApiResponse<IPrayer>> = db.executeSql(query, []).then((result:ISQLiteResponse<IPrayer>)=>{
                if(result.rows.length) {
                    const prayer = SQLiteHelperService.convertToJsTypes(result.rows.item(0));
                    console.log('sql prayer: ', prayer)
                    return  {...SuccessApiResponse, Data: prayer};
                } else {
                    return {
                        Data: undefined,
                        Success: false,
                        Message: { UserMessage: 'FAILED: COULD NOT FIND PRAYER', ServerMessage: 'FAILED TO GET' }
                    }
                }
            }).catch((error)=>{
                const response = {
                    Data: undefined,
                    Success: false,
                    Message: { UserMessage: error.toString(), ServerMessage: error.toString() }
                }
                console.log(error);
                return response as IApiResponse<IPrayer>;
            });
            return dbResponse;
        } else {
            return dbFailedResponse;
        }
    },

    getPrayersByStatus: async (prayerStatus: PrayerStatusValues) => {

        const query = `SELECT * FROM ${SQLiteTables.prayers} WHERE \`status\`='${prayerStatus}' ORDER BY \`order\` ASC`;
        const db = await SQLiteDB();
        if(db) {
            const dbResponse: Promise<IApiResponse<IPrayer[]>> = db.executeSql(query, []).then((result:ISQLiteResponse<IPrayer>)=>{
                return  {...SuccessApiResponse, Data: SQLiteHelperService.queryResultToArray(result, true) as IPrayer[]};
            }).catch((error)=>{
                const response = {
                    Data: undefined,
                    Success: false,
                    Message: { UserMessage: error.toString(), ServerMessage: error.toString() }
                }
                console.log(error);
                return response as IApiResponse<IPrayer[]>;
            });
            return dbResponse;
        } else {
            return dbFailedResponse;
        }
    },

    getAllPrayers: async () => {
        const query = `SELECT * FROM ${SQLiteTables.prayers} ORDER BY \`order\` ASC`;
        const db = await SQLiteDB();
        if(db) {
            const dbResponse: Promise<IApiResponse<IPrayer[]>> = db.executeSql(query, []).then((result:ISQLiteResponse<IPrayer>)=>{
                return  {...SuccessApiResponse, Data: SQLiteHelperService.queryResultToArray(result, true) as IPrayer[]};
            }).catch((error)=>{
                const response = {
                    Data: undefined,
                    Success: false,
                    Message: { UserMessage: error.toString(), ServerMessage: error.toString() }
                }
                console.log(error);
                return response as IApiResponse<IPrayer[]>;
            });
            return dbResponse;
        } else {
            return dbFailedResponse;
        }
    },

    updatePrayer: async (prayer, isSyncUpdate?) => {
        // If this an update from a cloud sync don't modify the date
        const updatedPrayer = isSyncUpdate ? prayer : {...prayer, modifiedDate: new Date(Date.now())};

        const query = SQLiteHelperService.updateQuery(SQLiteTables.prayers, updatedPrayer);
        const db = await SQLiteDB();

        if(db) {
            const dbResponse: Promise<IApiResponse<IPrayer>> = db.executeSql(query, []).then((result)=>{
                    const response = {...SuccessApiResponse, Data: prayer};
                    response.Message.UserMessage = 'SUCCESS: UPDATED PRAYER.';
                    return response;
            }).catch((error)=>{
                const response = {
                    Data: prayer,
                    Success: false,
                    Message: { UserMessage: error.toString(), ServerMessage: error.toString() }
                }
                console.log(error);
                return response as IApiResponse<IPrayer>;
            });

            return dbResponse;
        } else {
            return dbFailedResponse;
        }
    },

    updatePrayers: async (prayers) => {
        const queryArray = prayers.map(prayer => SQLiteHelperService.updateQuery(SQLiteTables.prayers, prayer));
        const db = await SQLiteDB();
        console.log(queryArray);
        if(db) {
            const dbResponse: Promise<IApiResponse<boolean>> = db.sqlBatch(queryArray).then((result)=>{
                    console.log(result);
                    return {...SuccessApiResponse, Data: true};
            }).catch((error)=>{
                const response = {
                    Data: false,
                    Success: false,
                    Message: { UserMessage: error.toString(), ServerMessage: error.toString() }
                }
                console.log(error);
                return response as IApiResponse<boolean>;
            });
            return dbResponse;
        } else {
            return dbFailedResponse;
        }
    },

    // This is no longer used so that syncing with the cloud will know to remove it from other devices
    deletePrayer: async (prayer) => {

        const query = `DELETE FROM ${SQLiteTables.prayers} WHERE \`id\`=${prayer.id}`
        const db = await SQLiteDB();

        if(db) {
            const dbResponse: Promise<IApiResponse<boolean>> = db.executeSql(query, []).then((result)=>{
                return {...SuccessApiResponse, Data: true};
            }).catch((error)=>{
                const response = {
                    Data: false,
                    Success: false,
                    Message: { UserMessage: error.toString(), ServerMessage: error.toString() }
                }
                console.log(error);
                return response as IApiResponse<boolean>;
            });
            return dbResponse;
        } else {
            return dbFailedResponse;
        }
    },
}

export default PrayerServiceHybrid;